import React, { useState } from "react";
import { motion } from "framer-motion";
import { Facebook } from "lucide-react";
import { useSelector } from "react-redux";
import { facebookText } from "../../i18n/facebook";
import background from "./light-yellow.jpg";
import { useEffect } from "react";
import { FacebookProvider, Page, Group, EmbeddedPost } from "react-facebook";

const Fbpost = () => {
  const lang = useSelector((state) => state.language.lang);
  const t = facebookText[lang];

  const [width, setWidth] = useState(500);

  useEffect(() => {
    const updateWidth = () => {
      const w = window.innerWidth;

      if (w < 640) {
        setWidth(400); // mobile padding
      } else if (w < 1024) {
        setWidth(400); // tablet
      } else {
        setWidth(500); // desktop
      }
    };

    updateWidth();
    window.addEventListener("resize", updateWidth);

    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  return (
    <section
      id="facebook"
      className="relative py-16 lg:py-24 overflow-hidden px-6 lg:px-6 "
      style={{ backgroundImage: `url(${background})` }}
    >
      {/* OVERLAY */}
      <div className="absolute inset-0 bg-white/80 backdrop-blur-sm" />

      <div className="relative max-w-6xl mx-auto ">
        <div className="grid lg:grid-cols-2 gap-10 items-center lg:items-start">
          {" "}
          {/* LEFT */}
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <p className="text-sm uppercase tracking-widest text-gray-500 mb-3">
              {t.subtitle}
            </p>

            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 leading-tight">
              {t.title} <br />
              <span className="text-yellow-600">{t.highlight}</span>
            </h2>

            <p className="text-gray-600 mt-5 max-w-md">{t.desc}</p>

            {/* CTA */}
            <a
              href="https://www.facebook.com/tiffanybuicareercounsellor"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 mt-6 px-6 py-3 rounded-full bg-navy text-white hover:bg-yellow-600 transition-all duration-300"
            >
              <Facebook size={18} />
              {t.cta}
            </a>
          </motion.div>
          {/* RIGHT */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6 }}
          >
            <div className="grid gap-16 items-center ">
              <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100">
                {/* HEADER */}
                <div
                  className="flex items-center justify-between px-5 py-4 border-b"
                  onClick={() =>
                    window.open(
                      "https://www.facebook.com/tiffanyhuongnghiep",
                      "_blank",
                    )
                  }
                >
                  <div>
                    <p className="font-semibold text-gray-900">{t.pageName}</p>
                    <p className="text-xs text-gray-500">{t.pageLabel}</p>
                  </div>

                  <Facebook
                    className="text-blue-600"
                    onClick={() =>
                      window.open(
                        "https://www.facebook.com/tiffanyhuongnghiep",
                        "_blank",
                      )
                    }
                  />
                </div>

                {/* IFRAME */}
                {/* <div className="flex justify-center">
                  <div
                    className="fb-page"
                    data-href="https://www.facebook.com/tiffanyhuongnghiep"
                    data-tabs="timeline"
                    data-width={width}
                    data-height="600"
                    data-adapt-container-width="true"
                    data-hide-cover="false"
                    data-show-facepile="true"
                  />
                </div> */}

                <FacebookProvider appId="211013638396718">
                  <Page
                    href="https://www.facebook.com/tiffanyhuongnghiep/"
                    tabs="timeline"
                    width={width}
                    height={750}
                  />
                </FacebookProvider>
                {/* FOOTER */}
                <div className="text-center py-3 text-sm text-gray-500">
                  {t.footer}
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Fbpost;
